<template>
  <div class="error-animation-container">
    <div class="error"></div>
  </div>
</template>

<script>
export default {
  name: 'Error',

}
</script>


<style scoped lang="scss">
@import 'D:\\inetpub\\MPortal\\src\\_variables';
.error-animation-container {
  position: relative;
  aspect-ratio: 1;
  height: 100%;
  margin: auto;
  .error {
    opacity: 1;
    position: absolute;
    transform-origin: top left;
    border-left: 2px solid $error;
    transform: rotate(45deg) translateX(53%) scale(-1);
    top: 50%;
    width: 71%;
    height: 0%;
    animation-duration: 400ms;
    animation-timing-function: ease;
    animation-name: error1;
    // animation-iteration-count: infinite;
    animation-delay: 400ms;
    animation-fill-mode: forwards;
  }
  &:after {
    content: ' ';
    opacity: 1;
    position: absolute;
    transform-origin: top left;
    border-left: 2px solid $error;
    transform: rotate(-45deg) translateX(-55%);
    left: 50%;
    width: 71%;
    height: 0%;
    animation-duration: 800ms;
    animation-timing-function: ease;
    animation-name: error2;
    animation-fill-mode: forwards;
    // animation-iteration-count: infinite;
  }
}

@keyframes error1 {
  0% {
    height: 0;
    opacity: 0;
  }
  20% {
    height: 14.2%;
    opacity: 0.8;
  }
  100% {
    height: 71%;
    opacity: 1;
  }
}
@keyframes error2 {
  0% {
    height: 0;
    opacity: 0;
  }
  20% {
    height: 28.4%;
    opacity: 0.8;
  }
  50% {
    height: 71%;
    opacity: 1;
  }
  100% {
    height: 71%;
    opacity: 1;
  }
}
</style>
